( function () {
    'use strict';
    /**
     * @namespace
     */
    master.dealersearch = {
        setWorkshop: function () {
            /** @function */
            /**
             * Set workshop and check if other workshop is selected, then clear cart

             * @async
             */
            jQuery( document ).on( 'click', '.js-maps-set-workshop', function ( event ) {
                event.preventDefault();
                event.stopPropagation();
                var jThis = jQuery( this ),
                    workshopID = jThis.data( 'workshop-id' ),
                    workshopName = jThis.data( 'workshop-name' ),
                    jCurrentWorkshopID = jQuery( 'meta[name="workshopID"]' );
                if ( jCurrentWorkshopID.length ) {
                    if ( parseInt( jCurrentWorkshopID.attr( 'content' ) ) !== parseInt( workshopID ) ) {
                        master.checkout.cart.commands.emptyCart();
                    }
                }
                jQuery.post( master.data.workshops.endpoint, {
                    action: master.data.workshops.actions.set,
                    workshop: workshopID
                }, function () {
                    sessionStorage.workshopSelected = workshopName;
                    master.tracking.toTrack( {
                        'fn': 'workshop',
                        args: [
                            workshopName,
                            location.href, 'Flueben på værkstedsoversigt'
                        ]
                    } );
                    //master.tracking.workshop( workshopName, location.href, 'Flueben på værkstedsoversigt' );
                    if ( sessionStorage.workshopReturnUrl !== null && sessionStorage.workshopReturnUrl !== undefined ) {
                        location.href = sessionStorage.workshopReturnUrl;
                    }
                    else {
                        location.reload();
                    }
                } );
            } );
        },
        /** @function */
        /**
         * Toggle mobile open class
         * @deprecated
         */
        mobilePopList: function () {
            jQuery( '.js-e-maps-full-page-list-toggle' ).on( 'click', function () {
                jQuery( '.js-e-maps-full-page-list' ).toggleClass( 'open' );
            } );
        },
        /** @function */
        /**
         * Logic to remember where user came from, so they can be returned, when a workshop is selected
         */
        popupSaveHistory: function () {
            jQuery( '.js-master-contact-popup-save-history' ).on( 'click', function () {
                sessionStorage.workshopReturnUrl = location.href;
                sessionStorage.contactModal = true;
            } );
            if ( sessionStorage.workshopReturnUrl === location.href && sessionStorage.contactModal === 'true' ) {
                jQuery( '#contactModal' ).modal( 'show' );
                sessionStorage.removeItem( 'workshopReturnUrl' );
                sessionStorage.removeItem( 'contactModal' );
            }
        },
        /** @function */
        /**
         * Filter based on permissions
         * @deprecated
         */
        permissions: function () {
            jQuery( 'input[name="filterWorkshopsOnMaps"]' ).on( 'change', function () {
                var jParam = jQuery( this ).val();
                if ( location.search !== '' ) {
                    if ( location.search.indexOf( 'filterWorkshops' ) > -1 ) {
                        if ( location.search.indexOf( 'dealerq' ) > -1 ) {
                            location.search = location.search.split( '&' )[ 0 ] + '&filterWorkshops=' + jParam;
                        }
                        else {
                            location.search = '?filterWorkshops=' + jParam;
                        }
                    }
                    else {
                        location.search = location.search + '&filterWorkshops=' + jParam;
                    }
                }
                else {
                    location.search = '?filterWorkshops=' + jParam;
                }
            } );
        },
        /** @function */
        /**
         * Minisearch -  not in use
         * @deprecated
         */
        minisearch: function () {
            jQuery( '.js-master-workshop-map-permissions-badge-search-result' ).on( 'blur keyup', function ( event ) {
                event.preventDefault();
                if ( event.type === 'blur' || ( event.type === 'keyup' && event.keyCode === 13 ) ) {
                    var searchQuery = jQuery.trim( jQuery( this ).text() );
                    if ( searchQuery !== '' && searchQuery !== co3.util.param.dealerq ) {
                        location.search = '?dealerq=' + searchQuery + ( co3.util.param.filterWorkshops !== undefined ? '&filterWorkshops=' + co3.util.param.filterWorkshops : '' );
                    }
                }
            } );
            jQuery( '.js-master-workshop-map-permissions-badge-search-result-clear' ).on( 'click', function ( event ) {
                event.preventDefault();
                location.search = ( co3.util.param.filterWorkshops !== undefined ? '?filterWorkshops=' + co3.util.param.filterWorkshops : '' );
            } );
        },
        init: function () {
            master.dealersearch.setWorkshop();
            master.dealersearch.permissions();
            master.dealersearch.popupSaveHistory();
            master.dealersearch.mobilePopList();
        }
    };
}() );
